import { css } from 'styled-components';

const custom = (obj = {}) => css`
  ${Object.entries(obj)
    .map(([key, value]) => `${key}: ${value};`)
    .join('\n')}
`;

export { custom };
